module.exports = __webpack_public_path__ + "a7759f4b75d224304ff37e9c601f47d2.pdf";